// External libraries
import React from 'react';

// Internal
import { Checkbox } from '@/components/Common';
import type { InputOnChange } from '@/types';
import { getContent } from '@/lib/content/content';
import { UNIQUE_INFORMATION_PROCESSING } from '@/lib/features/constants';
import { useStoreState } from '@/store';
import { errorStyleOverrides } from '../PrivacyStatement/StyledComponents';

// Legacy
// @ts-expect-error untyped-import
import { FieldError } from '@checkout/react-components';

type UniqueInformationProcessingCheckboxProps = {
  changeHandler: InputOnChange;
};

/**
 * The unique information processing checkbox is required for KR users.
 * Related feature flag: hasUniqueInformationProcessingCheckbox
 * Related ELMO: FEATURE_THIRD_PARTY_DATA_CONSENT
 * Related JIRA Epic: https://paypal.atlassian.net/browse/DTXOCOMPL-1687
 */
export const UniqueInformationProcessingCheckbox = ({
  changeHandler,
}: UniqueInformationProcessingCheckboxProps): JSX.Element => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const uniqueInformationProcessing = useStoreState(
    ({ form }) => form[UNIQUE_INFORMATION_PROCESSING],
  );
  const hasError = Boolean(uniqueInformationProcessing?.displayError);
  return (
    <div>
      <Checkbox
        aria-invalid={hasError}
        changeHandler={changeHandler}
        checked={uniqueInformationProcessing?.value}
        disabled={isFormSubmitting}
        id={UNIQUE_INFORMATION_PROCESSING}
        name={UNIQUE_INFORMATION_PROCESSING}
        isTermsCheckbox
        label={getContent('terms.processUniqueIdentification')}
        required={true}
        {...uniqueInformationProcessing}
      />
      {hasError && (
        <FieldError
          id={`${UNIQUE_INFORMATION_PROCESSING}-error`}
          styleOverrides={errorStyleOverrides}
        >
          {getContent('fieldErrors.common.valueMissing')}
        </FieldError>
      )}
    </div>
  );
};
